import { render, staticRenderFns } from "./ResetPasswordComponent.vue?vue&type=template&id=e5e44c06&scoped=true"
import script from "./ResetPasswordComponent.vue?vue&type=script&lang=js"
export * from "./ResetPasswordComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e44c06",
  null
  
)

export default component.exports